import { getFingerprintJSPromise } from './fingerprintjs'

export const FingerprintJSHeadersNames = {
  FINGERPINT_V2: 'x-fingerprint-v2',
  FINGERPINT_V2_VERSION: 'x-fingerprint-v2-version',
  FINGERPINT_V2_CHECKSUM: 'x-fingerprint-v2-checksum',
} as const

export type FingerprintJSHeaders = {
  [key in (typeof FingerprintJSHeadersNames)[keyof typeof FingerprintJSHeadersNames]]?: string
}

export const getFingerprintJSHeaders = async () => {
  const fingerprintJS = await getFingerprintJSPromise()

  return {
    [FingerprintJSHeadersNames.FINGERPINT_V2]: fingerprintJS?.visitorId,
    [FingerprintJSHeadersNames.FINGERPINT_V2_VERSION]: fingerprintJS?.version,
    [FingerprintJSHeadersNames.FINGERPINT_V2_CHECKSUM]:
      fingerprintJS != null
        ? JSON.stringify(fingerprintJS).length.toString()
        : undefined,
  }
}
